import React, { ReactElement, useRef } from 'react';

import StyledTypography from '../../../../shared/components/styled-typography/styled-typography';
import { useGetSearchTerm } from '../../../../shared/hooks/use-get-search-term/use-get-search-term.hook';
import {
  CAMPAIGNS,
  CAMPAIGNS_FEATURE,
} from '../../../../store/utils/files-names';
import SearchBar from '../../../shared/components/search-bar/SearchBar';
import { useClearText } from '../../../shared/components/search-bar/hooks/use-clear-text/use-clear-text.hook';
import { useInputHandlerEvent } from '../../../shared/hooks/use-input-event-handler/use-input-event-handler.hook';
import { useSearchHandlerEvent } from '../../../shared/hooks/use-search-event-handler/use-search-event-handler.hook';
import { useToggleFiltersVisibility } from '../../../shared/hooks/use-toggle-filters-visibility/use-toggle-filters-visibility.hook';
import { useAreCampaignsFiltersVisible } from '../../hooks/use-are-campaigns-filters-visible/use-are-campaigns-filters-visible.hook';
import { CampaignFilters } from '../../models/campaign-filters.model';
import {
  campaignsToggleFiltersVisibility,
  filterCampaignsByName,
} from '../../store/slices/campaigns.slice';
import { getCampaigns } from '../../thunks/get-campaigns.thunk';
import CampaignsFilters from '../campaigns-filters/campaigns-filters-container';
import { CampaignsTable } from './components/campaigns-table/campaigns-table';

const Campaigns = (): ReactElement => {
  const inputRef = useRef<HTMLInputElement>(null);
  const clearText = useClearText(inputRef, filterCampaignsByName, 'name');

  const campaignsSearchTerm = useGetSearchTerm(
    `${CAMPAIGNS_FEATURE}.${CAMPAIGNS}`,
    'name'
  );
  const areFiltersVisible = useAreCampaignsFiltersVisible();
  const toggleFiltersVisibility = useToggleFiltersVisibility(
    campaignsToggleFiltersVisibility
  );

  const handleInputEvent = useInputHandlerEvent<CampaignFilters>(
    'name',
    filterCampaignsByName
  );

  const handleSearchEvent = useSearchHandlerEvent(
    getCampaigns,
    `${CAMPAIGNS_FEATURE}.${CAMPAIGNS}`
  );

  return (
    <>
      <StyledTypography variant="h1" data-testid="campaigns-landing-page">
        Campaigns
      </StyledTypography>
      <SearchBar
        createRoutePath="/campaign-management/create/basic-information"
        searchInputPlaceholder="Campaign Name"
        filterButtonClickHandler={toggleFiltersVisibility}
        searchInputChangeHandler={handleInputEvent}
        searchOnSubmitHandler={handleSearchEvent}
        inputRef={inputRef}
        clearText={clearText}
        areFiltersVisible={areFiltersVisible}
        initialValue={campaignsSearchTerm}
      />
      {areFiltersVisible && <CampaignsFilters />}
      <CampaignsTable />
    </>
  );
};

export default Campaigns;
